module.exports = __webpack_public_path__ + "static/media/mobileScreenshot05.619a9656.jpg";